import type { Category } from './categories';

export interface ComicChapter {
  number: number;
  title: string;
  date: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  rating: number;
  description: string;
  status: '连载中' | '已完结';
  chapters: ComicChapter[];
  tags: string[];
  views: number;
  updatedAt: string;
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / Dubu（REDICE STUDIO）',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20solo%20leveling%20dark%20fantasy%20hunter%20with%20glowing%20blue%20eyes%20wearing%20black%20armor%20dramatic%20lighting%20epic%20composition%20against%20dark%20purple%20monster%20background%20professional%20illustration%20high%20detail&width=600&height=800&seq=comic-cover-solo-leveling&orientation=portrait',
    category: 'action',
    rating: 4.9,
    description: '10年前，世界上开始出现连接异次元的"门"，而门里会涌出凶恶的魔物。与此同时，一部分人类觉醒了特殊能力——猎人。被称为"人类最弱兵器"的E级猎人成振宇，在一次地下城探索中遭遇了生死危机。在濒死之际，他获得了神秘系统的能力，从此踏上了成为最强猎人的道路。',
    status: '已完结',
    chapters: [
      { number: 1, title: '第1话 - 开始', date: '2024-01-15' },
      { number: 2, title: '第2话 - 系统', date: '2024-01-22' },
      { number: 3, title: '第3话 - 觉醒', date: '2024-01-29' },
      { number: 4, title: '第4话 - 地下城', date: '2024-02-05' },
      { number: 5, title: '第5话 - 成长', date: '2024-02-12' },
      { number: 6, title: '第6话 - 试炼', date: '2024-02-19' },
      { number: 7, title: '第7话 - 突破', date: '2024-02-26' },
      { number: 8, title: '第8话 - 新的力量', date: '2024-03-04' },
      { number: 9, title: '第9话 - 对决', date: '2024-03-11' },
      { number: 10, title: '第10话 - 进化', date: '2024-03-18' },
      { number: 11, title: '第11话 - 王者归来', date: '2024-03-25' },
      { number: 12, title: '第12话 - 终章', date: '2024-04-01' },
    ],
    tags: ['热血', '奇幻', '战斗', '系统流'],
    views: 2850000,
    updatedAt: '2024-04-01',
  },
  {
    id: 'comic-2',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20omniscient%20reader%20viewpoint%20young%20man%20in%20white%20coat%20holding%20a%20book%20surrounded%20by%20apocalyptic%20cityscape%20with%20floating%20text%20dramatic%20cinematic%20lighting%20professional%20illustration&width=600&height=800&seq=comic-cover-omniscient-reader&orientation=portrait',
    category: 'fantasy',
    rating: 4.8,
    description: '金独子是一个普通的上班族，唯一的爱好是阅读一部名为《在灭亡的世界中生存的三种方法》的网络小说。这部连载了3149话的小说只有他一个读者。当小说完结的那一天，小说中的世界竟然变成了现实。凭借10年阅读累积的知识，金独子成为了唯一知道这个世界走向的人。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 唯一的读者', date: '2024-06-01' },
      { number: 2, title: '第2话 - 世界变了', date: '2024-06-08' },
      { number: 3, title: '第3话 - 第一个剧本', date: '2024-06-15' },
      { number: 4, title: '第4话 - 同伴', date: '2024-06-22' },
      { number: 5, title: '第5话 - 主线任务', date: '2024-06-29' },
      { number: 6, title: '第6话 - 幕后之人', date: '2024-07-06' },
      { number: 7, title: '第7话 - 王座之争', date: '2024-07-13' },
      { number: 8, title: '第8话 - 回归者', date: '2024-07-20' },
    ],
    tags: ['奇幻', '末世', '智斗', '小说改编'],
    views: 2100000,
    updatedAt: '2024-07-20',
  },
  {
    id: 'comic-3',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20style%20tower%20of%20god%20mysterious%20boy%20climbing%20a%20massive%20fantasy%20tower%20with%20magical%20blue%20energy%20and%20floating%20islands%20epic%20scale%20cinematic%20professional%20illustration&width=600&height=800&seq=comic-cover-tower-of-god&orientation=portrait',
    category: 'fantasy',
    rating: 4.7,
    description: '二十五夜是一个平凡的少年，他追逐着唯一的朋友——蕾哈尔，进入了传说中的神之塔。这座塔能够实现任何愿望，但攀登的过程充满了残酷的试炼。每一层都有不同的规则和考验，二十五夜必须在生死之间不断突破自我，同时揭开神之塔背后隐藏的秘密。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 塔之门', date: '2024-05-10' },
      { number: 2, title: '第2话 - 第一层', date: '2024-05-17' },
      { number: 3, title: '第3话 - 王冠游戏', date: '2024-05-24' },
      { number: 4, title: '第4话 - 守护者', date: '2024-05-31' },
      { number: 5, title: '第5话 - 同伴集结', date: '2024-06-07' },
      { number: 6, title: '第6话 - 试炼之层', date: '2024-06-14' },
      { number: 7, title: '第7话 - 隐藏之力', date: '2024-06-21' },
      { number: 8, title: '第8话 - 工房战', date: '2024-06-28' },
      { number: 9, title: '第9话 - 真相', date: '2024-07-05' },
      { number: 10, title: '第10话 - 新世界', date: '2024-07-12' },
    ],
    tags: ['奇幻', '冒险', '友情', '成长'],
    views: 1950000,
    updatedAt: '2024-07-12',
  },
  {
    id: 'comic-4',
    title: '伯爵家的混混',
    author: 'Yoo Ryeo Han / PAN4',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20fantasy%20noble%20young%20man%20with%20red%20hair%20wearing%20elegant%20medieval%20noble%20clothing%20holding%20a%20sword%20standing%20in%20front%20of%20a%20grand%20castle%20dramatic%20lighting%20professional%20illustration&width=600&height=800&seq=comic-cover-trash-count&orientation=portrait',
    category: 'fantasy',
    rating: 4.8,
    description: '我附身到了小说中注定会被主角杀死的反派——伯爵家的废物儿子身上。为了改变必死的命运，我决定彻底改变这个角色的形象。从修炼剑术开始，一步步证明自己不是废物。然而当我以为一切都在掌控之中时，原主角却提前出现了……',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 附身', date: '2024-06-15' },
      { number: 2, title: '第2话 - 废物之名', date: '2024-06-22' },
      { number: 3, title: '第3话 - 修炼', date: '2024-06-29' },
      { number: 4, title: '第4话 - 家族试炼', date: '2024-07-06' },
      { number: 5, title: '第5话 - 初露锋芒', date: '2024-07-13' },
      { number: 6, title: '第6话 - 主角登场', date: '2024-07-20' },
    ],
    tags: ['奇幻', '转生', '反派', '成长'],
    views: 1680000,
    updatedAt: '2024-07-20',
  },
  {
    id: 'comic-5',
    title: '剑尊归来',
    author: 'LICO / REDICE STUDIO',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20martial%20arts%20swordsman%20with%20long%20black%20hair%20wielding%20a%20glowing%20sword%20in%20traditional%20oriental%20setting%20with%20cherry%20blossoms%20and%20mountain%20landscape%20dramatic%20composition%20professional%20illustration&width=600&height=800&seq=comic-cover-swordmaster-return&orientation=portrait',
    category: 'action',
    rating: 4.9,
    description: '天下第一剑客——剑尊陈无极，在与魔教教主的最终决战中同归于尽。然而当他再次睁开眼睛时，发现自己竟然回到了二十年前，变成了陈家的废物少爷。带着前世所有的剑术记忆和战斗经验，他要在这个世界中重新崛起，夺回属于自己的一切。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 归来', date: '2024-07-01' },
      { number: 2, title: '第2话 - 废物之名', date: '2024-07-08' },
      { number: 3, title: '第3话 - 剑术大赛', date: '2024-07-15' },
      { number: 4, title: '第4话 - 震惊全场', date: '2024-07-22' },
    ],
    tags: ['武侠', '重生', '战斗', '爽文'],
    views: 1520000,
    updatedAt: '2024-07-22',
  },
  {
    id: 'comic-6',
    title: '甜蜜的陷阱',
    author: 'LEE Hye',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20style%20beautiful%20young%20woman%20and%20handsome%20man%20in%20modern%20Seoul%20cityscape%20background%20romantic%20atmosphere%20with%20cherry%20blossom%20petals%20falling%20soft%20warm%20lighting%20professional%20illustration&width=600&height=800&seq=comic-cover-sweet-trap&orientation=portrait',
    category: 'romance',
    rating: 4.6,
    description: '为了偿还家里的债务，林素恩不得不进入顶级娱乐公司做实习生。没想到第一天就遇到了传说中的冷面总裁——车敏赫。他总是用冰冷的态度对待她，却在关键时刻一次次出手相助。当素恩以为自己陷入了甜蜜陷阱，却发现这背后隐藏着一个更大的秘密。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 面试', date: '2024-07-05' },
      { number: 2, title: '第2话 - 第一天', date: '2024-07-12' },
      { number: 3, title: '第3话 - 意外相遇', date: '2024-07-19' },
      { number: 4, title: '第4话 - 特别任务', date: '2024-07-26' },
      { number: 5, title: '第5话 - 心动', date: '2024-08-02' },
    ],
    tags: ['恋爱', '总裁', '职场', '甜宠'],
    views: 1350000,
    updatedAt: '2024-08-02',
  },
  {
    id: 'comic-7',
    title: '大贵族',
    author: 'Son Jeho / Lee Kwangsu',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20vampire%20noble%20with%20silver%20hair%20and%20red%20eyes%20wearing%20elegant%20black%20suit%20standing%20in%20front%20of%20a%20modern%20school%20building%20with%20gothic%20elements%20dramatic%20atmosphere%20professional%20illustration&width=600&height=800&seq=comic-cover-noblesse&orientation=portrait',
    category: 'action',
    rating: 4.7,
    description: '拥有强大力量的贵族——卡迪斯·艾特拉马·迪·莱杰罗，在沉睡820年后醒来，进入了一所普通高中。在这个人类世界中，他结识了一群真诚的朋友。然而，暗中窥视贵族力量的组织开始蠢蠢欲动。为了保护珍视的人，贵族的力量再次觉醒。',
    status: '已完结',
    chapters: [
      { number: 1, title: '第1话 - 苏醒', date: '2024-03-01' },
      { number: 2, title: '第2话 - 学校', date: '2024-03-08' },
      { number: 3, title: '第3话 - 朋友', date: '2024-03-15' },
      { number: 4, title: '第4话 - 组织', date: '2024-03-22' },
      { number: 5, title: '第5话 - 冲突', date: '2024-03-29' },
      { number: 6, title: '第6话 - 真相', date: '2024-04-05' },
      { number: 7, title: '第7话 - 决战', date: '2024-04-12' },
      { number: 8, title: '第8话 - 终章', date: '2024-04-19' },
    ],
    tags: ['吸血鬼', '校园', '战斗', '友情'],
    views: 1780000,
    updatedAt: '2024-04-19',
  },
  {
    id: 'comic-8',
    title: '再见，我的公主',
    author: 'KIM Seol',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20style%20tragic%20princess%20in%20beautiful%20traditional%20hanbok%20dress%20crying%20under%20a%20cherry%20blossom%20tree%20in%20ancient%20Korean%20palace%20garden%20emotional%20soft%20lighting%20professional%20illustration&width=600&height=800&seq=comic-cover-goodbye-princess&orientation=portrait',
    category: 'romance',
    rating: 4.5,
    description: '朝鲜时代的公主李华珍，从小被当作政治联姻的工具。在命运的捉弄下，她爱上了敌国派来的质子。两人在重重阻碍中守护着脆弱的爱情。然而当国家利益与个人感情发生冲突时，公主必须做出最艰难的选择。',
    status: '已完结',
    chapters: [
      { number: 1, title: '第1话 - 公主', date: '2024-02-10' },
      { number: 2, title: '第2话 - 质子', date: '2024-02-17' },
      { number: 3, title: '第3话 - 相遇', date: '2024-02-24' },
      { number: 4, title: '第4话 - 秘密', date: '2024-03-02' },
      { number: 5, title: '第5话 - 约定', date: '2024-03-09' },
      { number: 6, title: '第6话 - 离别', date: '2024-03-16' },
    ],
    tags: ['古装', '恋爱', '悲剧', '历史'],
    views: 980000,
    updatedAt: '2024-03-16',
  },
  {
    id: 'comic-9',
    title: '鬼怪公寓',
    author: 'PARK Min',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20manhwa%20cover%20art%20style%20dark%20apartment%20building%20with%20ghostly%20figures%20in%20windows%20young%20woman%20looking%20scared%20holding%20a%20flashlight%20eerie%20blue%20lighting%20creepy%20atmosphere%20professional%20illustration&width=600&height=800&seq=comic-cover-ghost-apartment&orientation=portrait',
    category: 'thriller',
    rating: 4.6,
    description: '刚毕业的大学生金智恩搬进了一栋租金异常便宜的公寓。很快她就发现，这里的住户似乎都不太正常——半夜传来的脚步声、镜子里一闪而过的影子、总在凌晨三点响起的敲门声。随着调查深入，一桩二十年前的灭门惨案逐渐浮出水面。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 新家', date: '2024-07-08' },
      { number: 2, title: '第2话 - 邻居', date: '2024-07-15' },
      { number: 3, title: '第3话 - 声音', date: '2024-07-22' },
      { number: 4, title: '第4话 - 镜中人', date: '2024-07-29' },
      { number: 5, title: '第5话 - 往事', date: '2024-08-05' },
    ],
    tags: ['恐怖', '悬疑', '都市传说', '推理'],
    views: 1120000,
    updatedAt: '2024-08-05',
  },
  {
    id: 'comic-10',
    title: '高中生霸主',
    author: 'CHOI Gang',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20style%20high%20school%20student%20with%20fierce%20expression%20wearing%20school%20uniform%20standing%20on%20school%20rooftop%20with%20dramatic%20sunset%20sky%20and%20cityscape%20background%20powerful%20composition%20professional%20illustration&width=600&height=800&seq=comic-cover-highschool-king&orientation=portrait',
    category: 'action',
    rating: 4.4,
    description: '转学到首尔最混乱高中的朴泰俊，第一天就被学校里的不良团伙盯上了。然而没有人知道，他曾经是地下格斗场的冠军。面对接踵而至的挑衅和挑战，泰俊决定不再隐藏实力。在这所弱肉强食的高中里，他要成为真正的霸主。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 转学生', date: '2024-07-10' },
      { number: 2, title: '第2话 - 挑衅', date: '2024-07-17' },
      { number: 3, title: '第3话 - 实力', date: '2024-07-24' },
      { number: 4, title: '第4话 - 联盟', date: '2024-07-31' },
      { number: 5, title: '第5话 - 老大', date: '2024-08-07' },
    ],
    tags: ['校园', '格斗', '热血', '爽文'],
    views: 1250000,
    updatedAt: '2024-08-07',
  },
  {
    id: 'comic-11',
    title: '恶女的正义',
    author: 'JUNG Soo',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%20art%20style%20elegant%20noblewoman%20with%20black%20dress%20and%20cold%20expression%20holding%20a%20fan%20standing%20in%20luxurious%20Victorian%20ballroom%20with%20chandeliers%20dramatic%20lighting%20professional%20illustration&width=600&height=800&seq=comic-cover-villainess-justice&orientation=portrait',
    category: 'fantasy',
    rating: 4.7,
    description: '被冤枉致死的大小姐白雅琳，重生后回到了悲剧发生前的三年前。这一世，她不再是那个任人宰割的善良女孩。利用前世记忆中的一切，她要一步步揭露那些伪善者的真面目，让所有伤害过她的人付出代价。一场华丽的复仇大戏即将拉开帷幕。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 重生', date: '2024-07-12' },
      { number: 2, title: '第2话 - 计划', date: '2024-07-19' },
      { number: 3, title: '第3话 - 第一步', date: '2024-07-26' },
      { number: 4, title: '第4话 - 宴会', date: '2024-08-02' },
      { number: 5, title: '第5话 - 反击', date: '2024-08-09' },
    ],
    tags: ['重生', '复仇', '宫廷', '女强'],
    views: 1420000,
    updatedAt: '2024-08-09',
  },
  {
    id: 'comic-12',
    title: '深海恐惧',
    author: 'YOON Jae',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%20style%20deep%20ocean%20with%20giant%20mysterious%20sea%20creature%20shadow%20underwater%20divers%20in%20dark%20blue%20abyss%20with%20dramatic%20light%20rays%20penetrating%20water%20tense%20atmosphere%20professional%20illustration&width=600&height=800&seq=comic-cover-deep-sea-fear&orientation=portrait',
    category: 'thriller',
    rating: 4.5,
    description: '深海勘探队在太平洋最深处的马里亚纳海沟发现了一处异常信号源。当潜水器抵达万米深海时，船员们看到了人类从未见过的恐怖景象——巨大的未知生物正在从深渊中苏醒。而更令人绝望的是，他们的通讯和动力系统全部失灵了。',
    status: '连载中',
    chapters: [
      { number: 1, title: '第1话 - 深海', date: '2024-07-15' },
      { number: 2, title: '第2话 - 信号', date: '2024-07-22' },
      { number: 3, title: '第3话 - 下潜', date: '2024-07-29' },
      { number: 4, title: '第4话 - 深渊', date: '2024-08-05' },
    ],
    tags: ['科幻', '恐怖', '深海', '生存'],
    views: 1050000,
    updatedAt: '2024-08-05',
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter(c => c.category === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find(c => c.id === id);
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics
    .filter(c => c.id !== comic.id && (c.category === comic.category || c.tags.some(t => comic.tags.includes(t))))
    .slice(0, limit);
};

export const getHotComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};